import { Link } from '@tanstack/react-router';

/**
 * A donor or payee named on a preflight finding. A resolved contact links to its contact page,
 * where the treasurer fixes the record the finding is about; an unresolved one is plain text.
 */
export function PreflightContactName({
  name,
  contactId,
}: {
  name: string;
  contactId: string | null;
}) {
  if (!contactId) return <>{name}</>;
  return (
    <Link
      to="/admin/finance/contacts/$contactId"
      params={{ contactId }}
      className="underline underline-offset-2 hover:no-underline"
    >
      {name}
    </Link>
  );
}
